import './TableFilters.css'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { FilterConfig } from 'src/components/Tables/ServerTable'
import DateRangeFilter from 'src/components/Tables/DateRangeFilter'

type Props = {
  filters: FilterConfig[]
  searchParams: URLSearchParams
  setSearchParams: (params: URLSearchParams) => void
  showFilters: boolean
  filterPrefix?: string
}

const TableFilters: React.FC<Props> = ({
                                         filters,
                                         searchParams,
                                         setSearchParams,
                                         showFilters,
                                         filterPrefix,
                                       }) => {

  if (filters.length === 0) {
    return null
  }

  return (
    <div className="filter-container">
      <div className={`table-filters ${showFilters ? '' : 'filter-collapsed'}`}>
        {
          filters.map((filter) => {
            const { filterType, name, id, options, optionFormatter } = filter
            const currentValue = searchParams.get(`${filterPrefix}${id}`) || ''

            const handleChange = (id: string, value: string) => {
              const key = `${filterPrefix}${id}`
              if (value === '') {
                searchParams.delete(key)
              } else {
                searchParams.set(key, value)
              }
              // Reset page to 1 on any filter change
              searchParams.set(`${filterPrefix}page.current`, '1')

              setSearchParams(searchParams)
            }

            return (
              <div key={id} className={`filter-item ${showFilters ? '' : 'filter-collapsed'}`}>
                {/* Filter Header */}
                <label className="filter-label" htmlFor={`${filterPrefix}${id}`}>{name}</label>

                {/* Filter Control */}
                {(() => {
                  switch (filterType) {
                    case 'daterange':
                      return <DateRangeFilter id={id} onChange={(idDR, value) => {
                        handleChange(idDR, value)
                      }}
                      />
                    case 'select':
                      return (
                        <>
                          <select
                            id={id}
                            value={currentValue}
                            onChange={(e) => handleChange(id, e.target.value)}
                          >
                            <option value="" disabled={true}>{name}</option>
                            {options?.map((opt) => (
                              <option key={opt} value={opt}>
                                {optionFormatter ? optionFormatter(opt) : opt}
                              </option>
                            ))}
                          </select>
                          {
                            currentValue && (
                              <XMarkIcon className={'clear-filter-icon'}
                                         onClick={() => handleChange(id, '')}
                              />
                            )
                          }
                        </>
                      )
                    case 'checkbox':
                      return (
                        <label>
                          <input
                            type="checkbox"
                            checked={currentValue === 'true'}
                            onChange={(e) => handleChange(id, String(e.target.checked))}
                          />
                          {name}
                        </label>
                      )
                    case 'text':
                      return (
                        <>
                          <input
                            type="text"
                            id={id}
                            value={currentValue}
                            placeholder={name}
                            onChange={(e) => handleChange(id, e.target.value)}
                          />

                          {
                            currentValue && (
                              <XMarkIcon className={'clear-filter-icon'}
                                         onClick={() => handleChange(id, '')}
                              />
                            )
                          }
                        </>
                      )
                    default:
                      return null
                  }
                })()}
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default TableFilters
